import axiosInstance, { axiosMultipartFormDataInstance } from './axiosInstance';
import { API_PATH, API_VERSION } from './constants';

const dataSourcesService = {
   getDataSourcesList: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.DATASOURCES}`);
    },
    getDataSourceById: (companyId, dataSourceId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.DATASOURCES}/${dataSourceId}`);
    },
    createDataSources: (companyId, data) => {
        return axiosInstance.post(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.DATASOURCES}`, data);
    },
    updateDataSourceById: (companyId, dataSourceId, data) => {
        return axiosInstance.put(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.DATASOURCES}/${dataSourceId}`, data);
    },
    deleteDataSources: (companyId, data) => {
        return axiosInstance.post(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.DATASOURCES}/${API_PATH.DELETE}`, data);
    },
    dataSourceHistoryByPage: (companyId, page) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.DATASOURCES}/${API_PATH.LOGS}/${API_PATH.PAGEQUERY + page}`);
    },
    uploadDataSourceFile: (companyId, dataSourceId, file) => {
        return axiosMultipartFormDataInstance.post(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.DATASOURCES}/${dataSourceId}/${API_PATH.UPLOAD}`, file);
    },
    
}

export default dataSourcesService;
